module.exports = __webpack_public_path__ + "static/fonts/Spoqa-Han-Sans-Regular.544112e.woff2";